import * as Common from '@tfo/common'
import { observable } from 'mobx'
import { UserStore } from './UserStore'
import { LoginStore } from './LoginStore'
import { NotationStore } from './NotationStore'
import { ClientViewStore } from './ClientViewStore'
import { CreatePasswordController } from './CreatePasswordController'
import { ForgotCreatePasswordController } from './ForgotCreatePasswordController'

export default class RootStore {
	@observable userStore = new UserStore(this)
	@observable loginStore = new LoginStore(this)
	@observable notationStore = new NotationStore(this)
	@observable clientViewStore = new ClientViewStore(this)
	@observable createPasswordController = new CreatePasswordController(this)
	@observable forgotCreatePasswordController = new ForgotCreatePasswordController(this)
	network: Common.services.Network = new Common.services.Network()

	constructor() {
		if (Common.utils.loggedIn()) {
			this.login(Common.utils.COOKIE)
		}
	}

	login = (cookie?: string) => {
		//FIXME Manual init is brittle, make stores listen to each other
		this.network.authenticate(cookie)
		this.userStore.updateUser(Common.utils.getCookie(cookie))
		return this.clientViewStore.init()
	}
}
